import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, catchError, combineLatest, distinctUntilChanged, map, of, shareReplay, tap, throwError } from 'rxjs';
import { Strategy } from '../interfaces/models/strategy.model';


@Injectable({
  providedIn: 'root'
})
export class StrategyService {

  constructor(private http: HttpClient) { }
  private domain = environment.domain;
  private endPoint = 'strategies';

  //action stream
  private goalSearchterm = new BehaviorSubject<string>('');
  private selectedpillarSub = new BehaviorSubject<number>(0);
  private setStrategyIdSub = new BehaviorSubject<number>(0);

  // action stream observable
  strategyIdSub$ = this.setStrategyIdSub.asObservable().pipe(
    distinctUntilChanged(),
    tap(x => { if (x > 0) console.log('publishing strategyId', x); })
  )
  // action stream observable
  selectedPillar$ = this.selectedpillarSub.asObservable().pipe()
  // action stream observable
  goalSearchterm$ = this.goalSearchterm.asObservable().pipe()















  //all Strategies (non-deleted only)
  RawStrategies$ = this.http.get(this.domain + this.endPoint).pipe(
    shareReplay(1),
    map((data: any) => {
      const strategies = (data?.['data']?.['strategies'] as Strategy[]) ?? [];
      return strategies
        .filter((s: any) => !s?.is_deleted)
        .map((s: any) => ({
          ...s,
          pillars: (s?.pillars ?? []).filter((p: any) => !p?.is_deleted).map((p: any) => ({
            ...p,
            goals: (p?.goals ?? []).filter((g: any) => !g?.is_deleted)
          })),
          values: (s?.values ?? []).filter((v: any) => !v?.is_deleted)
        })) as Strategy[];
    }),
    catchError((err) => {
      console.error('RawStrategies$ failed', { err });
      return throwError(() => err);
    })
  )
  //default 
  defaultStrategy$ = this.RawStrategies$.pipe(map((strategies: Strategy[]) => strategies.find((x: any) => x.is_default)));
  defaultStrategPillars$ = this.defaultStrategy$.pipe(map((data: any) => data['pillars']))
  defaultStrategValues$ = this.defaultStrategy$.pipe(tap(data => console.log('to get value', data)), map(((data: any) => data['values'])))

  //when dropdown
  selectedStrategy$ = combineLatest([this.strategyIdSub$, this.RawStrategies$])
    .pipe(
      tap(([selectedStrategyId, strategies]) => {
        console.log(`strategies |  strategyId:${selectedStrategyId} =>`, strategies);
      }),
      map(([selectedStrategyId, strategies]) => {
        return selectedStrategyId ?
          strategies.find(x => x.id == selectedStrategyId) :
          strategies.find(x => x.is_default);
      }),
    )


  selectedStrategyPillars$ = this.selectedStrategy$.pipe(map((selectedStrategy) => {
    return (selectedStrategy?.pillars ?? []).filter((p: any) => !p?.is_deleted);
  }))

  // Goals based on the selected pillar (non-deleted only)
  selectedPillarsGoals$ = combineLatest([this.selectedPillar$, this.selectedStrategyPillars$]).pipe(map(([selectedPillarId, pillars]) => {
    const activePillars = (pillars ?? []).filter((p: any) => !p?.is_deleted);
    if (selectedPillarId == 0) {
      return activePillars.reduce((pre, currentPillar) => {
        const goals = (currentPillar.goals ?? [])
          .filter((g: any) => !g?.is_deleted)
          .map((x: any) => ({ ...x, pillar: currentPillar })) as any[];
        return [...pre, ...goals];
      }, [] as any[]);
    }
    const selectedPillar = activePillars.find(x => x.id == selectedPillarId);
    return (selectedPillar?.goals ?? [])
      .filter((g: any) => !g?.is_deleted)
      .map((x: any) => ({ ...x, pillar: selectedPillar })) as any[];
  }))
  filterdPillarsGoals$ = combineLatest([this.selectedPillarsGoals$, this.goalSearchterm$]).pipe(map(([goals, goalSearchterm]) => {
    if (goalSearchterm == '') {
      return goals
    }
    else {
      return goals?.filter((obj: any) => obj.name.toLowerCase().includes(goalSearchterm?.toLowerCase()) || obj.code.toLowerCase().includes(goalSearchterm.toLowerCase()));
    }
  }))
  //goals spesfic end 
  createStrategy(model: any) {
    return this.http.post(this.domain + this.endPoint, model).pipe(map((response: any) => {
      return response['data']['entity']
    }))
  }
  getStrategyById(id: any) {
    return this.http.get(this.domain + this.endPoint + '/' + `${id}`).pipe(
      map((response: any) => {
        const strategy = response?.['data']?.['strategy'];
        if (strategy) {
          strategy.pillars = (strategy.pillars ?? []).filter((p: any) => !p?.is_deleted).map((p: any) => ({
            ...p,
            goals: (p?.goals ?? []).filter((g: any) => !g?.is_deleted)
          }));
          strategy.values = (strategy.values ?? []).filter((v: any) => !v?.is_deleted);
          strategy.indicators = (strategy.indicators ?? []).filter((i: any) => !i?.is_deleted);
        }
        return response;
      })
    );
  }

  getStrategyAlignment(id: string) {

    return this.http.get(this.domain + this.endPoint + `/${id}/alignment`)
  }
  updateStrategy(model: any) {
    return this.http.put(this.domain + this.endPoint + `/${model.id}`, model)
  }
  deleteStrategy(id: number) {
    return this.http.delete(this.domain + this.endPoint + '/' + `${id}`)
  }
  //actions triggers 
  setStrategyIdfn(id: number) {
    this.setStrategyIdSub.next(id)
  }
  setSelectedPillarIdfn(id: number) {
    this.selectedpillarSub.next(id);
  }
  setGoalSearchtermfn(term: string) {
    this.goalSearchterm.next(term);
  }
  GetProjectPerformance(strategyId: number, projectId: number) {
    return this.http.get(this.domain + this.endPoint + `/${strategyId}/performance/projects/${projectId}`)
  }

  GetOrganizationHierarchy() {
    return this.http.get(this.domain + `hierarchy`)
  }
  GetTasks(strategyId: number) {
    return this.http.get(this.domain + `user/tasks?strategyId=${strategyId}`)
  }
  checkServerStatus() {
    return this.http.get(this.domain + 'ping').pipe(
      catchError(error => {
        if (error.status === 0) {
          console.error('Server is offline or network error');
          return of({ isOffline: true }); // Return observable indicating offline
        } else {
          return throwError(error); // Re-throw other errors
        }
      })
    );
  }
}
